import { Building2, FileText, Users } from 'lucide-react'
import { TFunction } from 'i18next'
import SuppliersList from './SuppliersList'
import ContractsList from './ContractsList'
import SupplierCandidates from './SupplierCandidates'

export const tabs = (t: TFunction) => [
    {
        label: t('suppliers'),
        value: 'suppliers',
        startIcon: <Building2 className="w-4 h-4" />,
        component: <SuppliersList />,
    },
    {
        label: t('pending_confirmation'),
        value: 'supplier-candidates',
        startIcon: <Users className="w-4 h-4" />,
        component: <SupplierCandidates />,
    },
    {
        label: t('contracts'),
        value: 'contracts',
        startIcon: <FileText className="w-4 h-4" />,
        component: <ContractsList />,
    },
]
